<!-- 考证辅导 (教师端)-->
<template>
  <div class="el-TCoach">
    <el-row class="content_block mb30">
      <TitleInfo title="考证辅导" :titleImg="fudao"></TitleInfo>
      <el-row class="pt30 pl30 coach_list">
        <ul>
          <template v-for="(item, index) in myAppsList" >
            <li :key="index">
              <span class="num_coach">{{index + 1}}</span>
              <el-row>
                <p class="title_coach limit_line_one fontB">{{item.courseInfoName}}</p>
              </el-row>
              <el-row class="tc mt30 mb30">
                <el-col :span="12" class="tc">&nbsp;
                  <!-- <i class="el-icon-view c_p" style="font-size: 30px;color: #2789E2;" @click="coachExamList(item,index)"></i>
                  <br>
                  <el-link style="margin-top: 10px;" @click="coachExamList(item)" :underline="false">查看详情</el-link>
                  -->
                </el-col>
                <el-col :span="12" class="tc">
                <i class="el-icon-tickets c_p" style="font-size: 30px;color: #395FEC;" @click="setCoach(item)"></i>
                  <br>
                  <el-link style="margin-top: 10px;" @click="setCoach(item)" :underline="false">考试信息</el-link>
                </el-col>
              </el-row>
            </li>
          </template>
        </ul>
        <el-empty v-if="myAppsList.length <= 0" description=""></el-empty>
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[6, 12, 20, 40]"
        :page-size="limit"
        background
        class="m20 t_r"
        :hide-on-single-page="true"
        layout="sizes, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </el-row>

    <!-- 新增题库作业 -->
    <el-dialog
      title="新增题库作业"
      :visible.sync="homewordk_add_dialog"
      class="dialog_"
      width="900px">
      <HomeworkAdd ref="homeworkAdd"
      :classList="classList"
      v-if="homewordk_add_dialog"
      :homeInfo="homeInfo"
      :courseId="courseId"></HomeworkAdd>
      <span slot="footer" class="dialog-footer">
        <el-button @click="homewordk_add_dialog = false">取 消</el-button>
        <el-button type="primary" @click="homewordkAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
import HomeworkAdd from "./HomeworkAdd"; //页面头部
export default {
  name: "Coach",
  components: {
  	TitleInfo,
    HomeworkAdd
  },
  data() {
    return {
      fudao:require("../../images/coach/fudao@2x.png"),
      myAppsList:[],
      total: 0,
      limit:6,
      page:1,
      homewordk_add_dialog:false,
      classList:[],
      homeInfo:{}, //作业信息  编辑时使用
      courseId:"",
      timeIn:null
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
    //this.addSystem();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        courseInfoStatus:1,
        courseInfoType: 1,
        courseLabelTypes:'考证课程类'
      }
      this.$post("/api/courseInfo/getKzPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.myAppsList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    coachExamList(item){ //详情
      this.$ls.set(this.$getKeyInfo("logName"),item.courseInfoName); //用于使用记录
      this.$router.push({name:'TCoachExamDetailed',query:{courseId:item.courseInfoId,courseInfoName:item.courseInfoName}});
    },
    setCoach(item){ //考证list
      // this.courseId = item.courseInfoId;
      // this.homewordk_add_dialog = true;
      this.$ls.set(this.$getKeyInfo("logName"),item.courseInfoName); //用于使用记录
      this.$router.push({name:'TCoachExamList',query:{courseId:item.courseInfoId,courseInfoName:item.courseInfoName}});
    },
    homewordkAdd(){ //保存新增题库信息
      let addForm = this.$refs.homeworkAdd.form; //获取新增题库数据
      let time = this.$refs.homeworkAdd.time; //获取新增题库数据
      let classIds = this.$refs.homeworkAdd.classIds; //获取新增题库数据
      if(this.$isEmpty(addForm.generalQuestionSettingName)){
        this.$message({message: '请输入作业名称！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(classIds)){
        this.$message({message: '请选择作业班级！',type: 'warning'});
        return;
      }else{
        addForm.generalQuestionSettingSchoolClassIds = classIds.join(",");
      }
      if(time.length <= 0){
        this.$message({message: '请选择作业时间！',type: 'warning'});
        return;
      }else{
        addForm.generalQuestionStartTime = time[0];
        addForm.generalQuestionEndTime = time[1];
      }
      if(this.$isEmpty(addForm.generalQuestionSettingDoCount)){
        this.$message({message: '请输入作业次数！',type: 'warning'});
        return;
      }
      let questionSettingOptions = this.$refs.homeworkAdd.questionSettingOptions; //获取新增题库数据
      if(this.$isEmpty(questionSettingOptions)){
        this.$message({message: '请设置题目！',type: 'warning'});
        return;
      }
      // addForm.questionSettingOptions = JSON.stringify(questionSettingOptions);
      addForm.questionSettingOptions = questionSettingOptions;
      this.submitInfo(addForm);
    },
    submitInfo(addForm){
      addForm.businessType = "FROM_SYSTEM"; //作业类型
      addForm.businessId = this.courseId;
      this.$postJSON("/api/generalQuestionSetting/addQuestionByType.do", addForm )
        .then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.homewordk_add_dialog = false;
            this.$message({type: 'success',message: '提交成功！'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
      });
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"考证辅导",//一级名称
          secondName:"考证辅导",//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-TCoach{
    padding: 20px 20px 0;
    .coach_list{
      min-height: 320px;overflow: auto;
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        float: left;
        width: 260px;
        height: 120px;
        padding: 20px;
        margin: 0 30px 30px 0;
        border: 1px solid #E1E1E1;
        background-image: url("../../images/course/num_bg@2x.png");
        background-size: 50px;
        background-repeat:no-repeat;
        position: relative;
      }
      .num_coach{
        position: absolute;top: 10px;left: 10px;color: #2789E2;
      }
      .title_coach{
        margin: 0;
        margin-left: 20px;float: left;
        width: calc(100% - 10px);
      }
      .coach_img{
        width: 25px;
        height: 25px;
      }
    }

    .content_block{
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .thirdParty_img{
      width: 310px;
      height: 176px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/certificate/TCoach.vue